import React, { FC, useContext, useMemo } from 'react'
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box'
import Avatar from '@mui/material/Avatar'
import Typography from '@mui/material/Typography'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction'
import IconButton from '@mui/material/IconButton'
import Divider from '@mui/material/Divider'
import DoneIcon from '@mui/icons-material/Done'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'

import BookingContext from '../contexts/booking'

import {
  getTitle as getPriceTitle,
} from '@kaidam/fc-shared/src/utils/price'

const BookingProduct: FC<React.PropsWithChildren<unknown>> = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const booking = useContext(BookingContext)

  const html = useMemo(() => {
    return {
      welcome_text: booking.generalConfig.welcome_text ? booking.renderLayout(booking.generalConfig.welcome_text) : '',
      pricing_header: booking.generalConfig.pricing_header ? booking.renderLayout(booking.generalConfig.pricing_header) : '',
      pricing_footer: booking.generalConfig.pricing_footer ? booking.renderLayout(booking.generalConfig.pricing_footer) : '',
    }
  }, [
    booking.generalConfig,
    booking.renderLayout,
  ])

  return (
    <Box sx={{ display: 'flex', p: 2 }}>
      <Box sx={{ width: '100%', p: 3, zIndex: 100 }}>
        {html.pricing_header && (
          <>
            <Box sx={{ mt: 2, mb: 2 }}>
              <div dangerouslySetInnerHTML={{__html: html.pricing_header}} />
            </Box>
            <Divider sx={{ mt: 2, mb: 2 }} />
          </>
        )}
        
        <Box sx={{ pl: 1 }}>
          <Typography
            align="left"
            gutterBottom
            variant="body1"
          >
            Choose the size of your house:
          </Typography>
        </Box>

        <List>
          {booking.products.map(product => (
            <ListItem
              key={product.name}
              button
              onClick={() => {
                booking.update({
                  product,
                  date: '',
                })
                booking.openPage('calendar')
              }}
            >
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: 'primary.main' }}>
                  <DoneIcon />
                </Avatar>
              </ListItemAvatar>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: isMobile ? 'column' : 'row',
                  width: '100%',
                  pr: 6,
                }}
              >
                <ListItemText
                  sx={{
                    width: isMobile ? '100%' : '50%',
                    mb: isMobile ? 1 : 0,
                  }}
                  primary={product.name}
                  secondary={getPriceTitle(product.price * 100)}
                />
                <ListItemText
                  sx={{
                    width: isMobile ? '100%' : '50%',
                    mb: isMobile ? 1 : 0,
                  }}
                  secondary={product.comment}
                />
              </Box>
              <ListItemSecondaryAction>
                <IconButton
                  edge="end"
                  aria-label="delete"
                  onClick={() => {
                    booking.update({
                      product,
                      date: '',
                    })
                    booking.openPage('calendar')
                  }}
                  size="large"
                >
                  <PlayArrowIcon color="primary" />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>

        {html.pricing_footer && (
          <Box sx={{ mt: 2, mb: 2 }}>
            <div dangerouslySetInnerHTML={{__html: html.pricing_footer}} />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default BookingProduct